import { render, staticRenderFns } from "./footer-bar.vue?vue&type=template&id=056ab246&"
import script from "./footer-bar.vue?vue&type=script&lang=js&"
export * from "./footer-bar.vue?vue&type=script&lang=js&"
import style0 from "./footer-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports